const SHOP_POPUP_MESSAGE_SESSION_PREFIX = 'shop-popup-message:'
const readMessageHashes = new Set<string>()

const getSessionKey = (contentHash: string): string => `${SHOP_POPUP_MESSAGE_SESSION_PREFIX}${contentHash}`

/*
 *  Checks whether a popup message was marked as read in memory or in the current browser session.
 */
export const isShopPopupMessageRead = (contentHash: string): boolean => {
  if (readMessageHashes.has(contentHash)) return true

  try {
    const isRead = sessionStorage.getItem(getSessionKey(contentHash)) !== null
    if (isRead) readMessageHashes.add(contentHash)
    return isRead
  } catch {
    return false
  }
}

/*
 * Marks a popup message as read for the current browser session, with an in-memory fallback when session storage is unavailable.
 */
export const markShopPopupMessageAsRead = (contentHash: string): void => {
  try {
    sessionStorage.setItem(getSessionKey(contentHash), 'true')
  } catch {
    readMessageHashes.add(contentHash)
  }
}
